import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_COLORS, humanize } from '../constants';

/** Chip whose color is derived from a semantic status token. */
export default function StatusChip({ status, label, size = 'small' }) {
  if (status === undefined || status === null || status === '') return null;
  const color = STATUS_COLORS[status] || 'default';
  return (
    <Chip
      size={size}
      color={color}
      variant={color === 'default' ? 'outlined' : 'filled'}
      label={label ?? humanize(status)}
      sx={{ fontWeight: 600 }}
    />
  );
}
